// AUTO GENERATED FILE - DO NOT EDIT - GENERATED BY cmd/enterprise/*.go generate authz
export default {
	status: 'success',
	data: {
		resources: [
			{
				kind: 'factor-api-key',
				type: 'metaresource',
			},
			{
				kind: 'role',
				type: 'role',
			},
			{
				kind: 'serviceaccount',
				type: 'serviceaccount',
			},
		],
		relations: {
			assignee: ['role'],
			attach: ['metaresource', 'role', 'serviceaccount'],
			create: ['metaresource', 'role', 'serviceaccount'],
			delete: ['metaresource', 'role', 'serviceaccount'],
			detach: ['metaresource', 'role', 'serviceaccount'],
			list: ['metaresource', 'role', 'serviceaccount'],
			read: ['metaresource', 'role', 'serviceaccount'],
			update: ['metaresource', 'role', 'serviceaccount'],
		},
	},
} as const;
